module.exports = __webpack_public_path__ + "img/vertical_3_6_3016.d71b3932.png";